<template>
  <canvas ref="canvas" />
</template>

<script>
import QRCode from 'qrcode'

export default {
  name: 'QrCode',
  props: {
    text: {
      type: String,
      required: true
    },
    size: {
      type: Number,
      default: 240
    },
    level: {
      type: String,
      default: 'H'
    },
    margin: {
      type: Number,
      default: 0
    }
  },
  mounted () {
    this.render()
    this.$watch(vm => [vm.text, vm.size, vm.level].join(), val => {
      this.render()
    })
  },
  methods: {
    async render () {
      try {
        await QRCode.toCanvas(this.$refs.canvas, this.text, {
          errorCorrectionLevel: 'H',
          margin: this.margin,
          width: this.size
        })
      } catch (e) {
        console.error(e)
      }
    }
  }
}
</script>
